import getLieOptions from './default-options/line';
import getBarOptions from './default-options/bar';
import getPieOptions from './default-options/pie';
import echart from '../echart.vue';
import AttomDesc from '@/components/attom-desc.vue'

export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        subTitle: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: 'line'
        },
        chartStyle: {
            type: Number,
            default: 1
        },
        options: {
            type: Object,
            default: () => ({})
        },
        notMerge: {
            type: Boolean,
            default: false
        },
        renderer: {
            type: String,
            default: 'canvas'
        },
        showAttom: {
            type: Boolean,
            default: false
        },
        noDataDesc: {
            type: String,
            default: ''
        },
        hasData: {
            type: Boolean,
            default: false
        }
    },
    data: function() {
        return {
            empty: true
        };
    },
    computed: {
        initOptions() {
            switch (this.type) {
            case 'line':
                return getLieOptions(this.chartStyle);
            case 'bar':
                return getBarOptions(this.chartStyle);
            case 'pie':
                return getPieOptions(this.chartStyle);
            default:
                return null;
            }
        }
    },
    methods: {
        update() {
            this.empty = false;
        }
    },
    components: {
        echart,
        AttomDesc
    }
};
